import { grid, list } from '../js/template/postArchive'

//post url
initPosturl();

// handling on click of the filter menu
$('.__filter').on('click', function() {
	let $this = $(this)
	let featured = ''
	let count = $this.attr('data-count')
	let page = Number($this.attr('data-page'))
	let type = $this.attr('data-type').split(',')
	if($this.attr('data-feature')) {
		featured = JSON.parse($this.attr('data-feature'))
	}
	let categoryId = $this.attr('data-category')
	let orderBy = $this.attr('data-order-by')
	let showDate = $this.attr('data-show-date')
	let listType = $this.attr('data-list-type')
	let category = [categoryId]

	if (categoryId == 'all') {
		category = []
	}

	getData(
		$this,
		{
			count,
			page,
			type,
			category,
			orderBy
		},
		showDate,
		listType,
		featured,
		'replace'
	)

	$this
		.parent('.filters')
		.siblings('.search')
		.children('input')
		.attr('data-category', categoryId)
	$this
		.parent('.filters')
		.find('.__filter')
		.removeClass('active')
	$this.addClass('active')
	
	if($('.__load-more').length > 0) {
		$('.__load-more').attr('data-category', categoryId)
	}

	return
})

// handling search filter
$('.__search').on('keypress', function() {
	let $this = $(this)
	let featured = ''
	let query = $this.val()
	let count = $this.attr('data-count')
	let page = Number($this.attr('data-page'))
	let type = $this.attr('data-type').split(',')
	if($this.attr('data-feature')) {
		featured = JSON.parse($this.attr('data-feature'))
	}
	let categoryId = $this.attr('data-category')
	let orderBy = $this.attr('data-order-by')
	let showDate = $this.attr('data-show-date')
	let listType = $this.attr('data-list-type')
	let category = [categoryId]

	if (categoryId == 'all') {
		category = 'all'
	}

	if (query != '') {
		getData(
			$this,
			{
				count,
				page,
				type,
				category,
				orderBy,
				query
			},
			showDate,
			listType,
			featured,
			'replace'
		)
	}

	return
})

// handling load more
$('.__load-more').on('click', function() {
	let $this = $(this)
	let featured = ''
	let count = $this.attr('data-count')
	let page = Number($this.attr('data-page'))
	let type = $this.attr('data-type').split(',')
	if($this.attr('data-feature')) {
		featured = JSON.parse($this.attr('data-feature'))
	}
	let category = $this.attr('data-category')
	let orderBy = $this.attr('data-order-by')
	let showDate = $this.attr('data-show-date')
	let listType = $this.attr('data-list-type')
	page = page + 1
	
	getData(
		$this,
		{
			count,
			page,
			type,
			category,
			orderBy
		},
		showDate,
		listType,
		featured,
		'append'
	)
	initPosturl();
	return
})

function getData($this, data, showDate, listType, featured, action = 'append') {
	let $posts = $('._posts_')

	$.ajax({
		url: '/wp-admin/admin-ajax.php',
		dataType: 'json',
		data: {
			action: 'get_archive_posts',
			...data
		},
		success: function(result) {
			if (result.length) {
				if (action == 'replace') {
					$posts.html('')
				}
				for (let i = 0; i < result.length; i++) {
					const element = result[i]

					if (showDate == 'yes') {
						let date = new Date(element.post_date)
						element.date = formatDT(date) 
					}

					let html = ``

					if (action == 'replace' && featured && i == 0) {
						html = list(element, featured)
					} else {
						html =
							listType == 'grid' ? grid(element) : list(element)
					}

					$this.attr('data-page', data.page)
					$posts.append(html)
				}
			}

			if (data.page == 2 && !result.length) {
				$posts.html('')
			}

			if (action == 'append') {
				if (result.length == 0 || result.length < data.count) {
					$this.hide()
				}
			}
			initPosturl();
		}
	})
}

function formatDT(inputDate) {
	let date, month, year;
  
	date = inputDate.getDate();
	month = inputDate.getMonth() + 1;
	year = inputDate.getFullYear();
  
	  date = date
		  .toString()
		  .padStart(2, '0');
  
	  month = month
		  .toString()
		  .padStart(2, '0');
  
	return `${date}-${month}-${year}`;
  }

function initPosturl() {
	$('.archive-card-grid').on('click', function() {
		let postUrl = $(this).attr('data-posturl');
		if(postUrl != '') {
			location.href = postUrl;
		}
		else {
			return false;
		}
	});
}

